import { ITheme, StoreMetadata } from "@commons-monorepo/types";
import { createContext } from "react";

type CategoriesType = {
  theme: ITheme;
  data: string[];
  partnerId: string;
  storeMetadata: StoreMetadata;
};

export const CategoriesContext = createContext<CategoriesType>({
  theme: {} as ITheme,
  data: [],
  partnerId: "",
  storeMetadata: {} as StoreMetadata,
});
